import { render } from "./SaberTypes.vue?vue&type=template&id=5ee9ef12&ts=true"
import script from "./SaberTypes.vue?vue&type=script&lang=ts"
export * from "./SaberTypes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__